<div id="jstree-basic" style="display: block;">
    <ul>
        <li data-jstree='{"icon" : "ti ti-folder"}'>
            {{cellValue.value}}
        </li>
    </ul>
</div>